import * as React from 'react';

import * as styles from './HighlightingTooltip.css';

interface IHighlightingTooltipProps {
  top: number;
}

export const HighlightingTooltip: React.FC<React.PropsWithChildren<IHighlightingTooltipProps>> = ({
  top,
  children,
}) => {
  return (
    <div style={{ top }} className={styles['container']}>
      <div className={styles['inner']}>{children}</div>
    </div>
  );
};
